module.exports = __webpack_public_path__ + "img/haris.c8bbceb9.webp";